import {Tabs, Tab, Grid} from '@mui/material';
import {useTranslation} from "react-i18next";
import {observer} from 'mobx-react';
import React from 'react';
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import {TAB_SPEC, TAB_LIFER} from './StatsCommon.js';
import StatsTaxons from './StatsTaxons.js';
import StatsLifer from './StatsLifer.js';

const StatsSpecies = observer((props) => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	const handleTabChange = (event, tab) => {
		gStorage.stats.setObsList(null);
		gStorage.stats.setSpecTab(tab + TAB_LIFER);
	}

	if (gStorage.stats.tab !== TAB_SPEC)
		return null;

	return (
		<>
			<Grid container direction="row" justifyContent="center" spacing={0} columns={1}>
				<Tabs
					value={gStorage.stats.spec_tab - TAB_LIFER}
					onChange={handleTabChange} 
					align={'center'}
					indicatorColor="primary"
					textColor="primary"
					scrollButtons="auto"
					variant="scrollable"
					sx={{mb: 1}}>
					<Tab label={t('stats.lifers')} disabled={!gStorage.conn.online}/>
					<Tab label={t('stats.taxons')} disabled={!gStorage.conn.online}/>
				</Tabs>
			</Grid>

			<StatsLifer/>
			<StatsTaxons/>
		</>
	);
});

export default StatsSpecies;
